/**
 * Página dedicada del Asistente Director IA
 * Acceso completo al asistente con historial y funcionalidades avanzadas
 */

import React from 'react';
import AsistenteChat from '../components/AsistenteChat';
import { useAuth } from '../context/AuthContext';
import { Bot, Shield } from 'lucide-react';

const Asistente = () => {
  const { user } = useAuth();
  
  // Verificar permisos
  if (user?.rol !== 'direccion') {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh]">
        <div className="bg-red-50 border border-red-200 rounded-xl p-8 text-center max-w-md">
          <Shield className="w-16 h-16 text-red-400 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-red-800 mb-2">Acceso Restringido</h2>
          <p className="text-red-600">
            El Asistente Director IA solo está disponible para usuarios con rol de dirección.
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="h-[calc(100vh-120px)]">
      <AsistenteChat enPagina={true} />
    </div>
  );
};

export default Asistente;
